type EnvKey =
  | "REACT_APP_WIDGET_BASE_URL"
  | "REACT_APP_TRANSLATIONS_PATH"
  | "REACT_APP_PUBLIC_ASSET_BASE_URL"
  | "REACT_APP_FLAG_ASSET_BASE_URL";

function getEnv(key: EnvKey): string {
  return process.env[key] ?? "";
}

export function joinUrl(baseUrl: string, path: string): string {
  const normalizedBaseUrl = baseUrl.replace(/\/+$/, "");
  const normalizedPath = path.replace(/^\/+/, "");

  if (!normalizedPath) {
    return normalizedBaseUrl || "/";
  }

  if (!normalizedBaseUrl) {
    return `/${normalizedPath}`;
  }

  return `${normalizedBaseUrl}/${normalizedPath}`;
}

export const config = {
  widgetBaseUrl: getEnv("REACT_APP_WIDGET_BASE_URL"),
  translationsPath: getEnv("REACT_APP_TRANSLATIONS_PATH"),
  publicAssetBaseUrl: getEnv("REACT_APP_PUBLIC_ASSET_BASE_URL"),
  flagAssetBaseUrl: getEnv("REACT_APP_FLAG_ASSET_BASE_URL"),
} as const;

export function translationUrl(lang: string): string {
  return joinUrl(
    joinUrl(config.widgetBaseUrl, config.translationsPath),
    `${lang}.json`
  );
}

export function publicAssetUrl(path: string): string {
  return joinUrl(config.publicAssetBaseUrl, path);
}

export function flagAssetUrl(path: string): string {
  return joinUrl(config.flagAssetBaseUrl, path);
}
